import { ValidationObserver, ValidationProvider } from "vee-validate";
import { v4 as uuidv4 } from 'uuid';
import { MailingMethods } from "@/enums/MailingMethods";
import { ResidentStatus } from "@/enums/ResidentStatus";
import { FamilyHubAppStatus } from "@/enums/FamilyHubAppStatus";
import { FamilyHubUserStatus } from "@/enums/FamilyHubUserStatus";
import { MailingListContactTypes } from "@/enums/MailingTypes";

export default {
  name: "AddContactDialog",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      customContact: this.getEmptyCustomContactTemplate(),
      mailingMethods: MailingMethods,
      mode: MailingMethods.Manual,
      csv: null,
      csvData: null,
      filename: null,
      isError: false,
      errorContent: "",
      contactsTypes: [MailingListContactTypes.Staff, MailingListContactTypes.Resident, MailingListContactTypes.Family],
      selectedContacts: [],
      selectedTypeOfContacts: null,
      contactSearch: "",
      mailing: {
        to: [],
        method: ''
      }
    };
  },
  computed: {
    currentMailingList() {
      return this.$store.state.facilityModule.facilityMailingCurrent;
    },
    isCustomContact() {
      return this.mode === this.mailingMethods.Manual;
    },
    isStaffHubContacts() {
      return this.mode === this.mailingMethods.StaffHub;
    },
    residents() {
      return this.$store.state.residentModule.residentsShortData
        .filter(x => x.email?.length > 0 && x.status !== ResidentStatus.Departed)
        .map(x=>({id: x.id, name: x.name, email: x.email, userType: MailingListContactTypes.Resident}))
    },
    familyMembers() {
      return this.$store.state.residentModule.familyMembers
        .filter(x => x.email?.length > 0 && x.appStatus === FamilyHubAppStatus.Activated 
          && x.status !== FamilyHubUserStatus.Archived)
        .map(x=>({id: x.id, name: x.name, email: x.email, userType: MailingListContactTypes.Family}))
    },
    staffUsers() {
      return this.$store.state.facilityModule.selectedFacilityUsers
        .filter(x => x.email?.length > 0 && !x.fileClosed)
        .map(x=>({id: x.id, name: x.name, email: x.email, userType: MailingListContactTypes.Staff}))
    },
    contactsList() {
      if(this.selectedTypeOfContacts === MailingListContactTypes.Staff) return this.staffUsers
      else if(this.selectedTypeOfContacts === MailingListContactTypes.Resident) return this.residents
      else if(this.selectedTypeOfContacts === MailingListContactTypes.Family) return this.familyMembers

      return [];
    },
    computedContactsList() {
      return [{ id: null, name: this.$t('GeneralTranslations.SelectAll') }, ...this.contactsList];
    },
    allSelected() {
      return this.contactsList.length > 0 &&
      this.selectedContacts.length === this.contactsList.length;
    },
    someSelected() {
      return this.selectedContacts.length > 0 &&
        this.selectedContacts.length < this.contactsList.length;
    }
  },
  methods: {
    async submit() {
      this.loading = true;

      if (this.mode === this.mailingMethods.Manual) {
        this.checkIfUserAlreadyAdded();
      } 
      else if (this.mode === this.mailingMethods.StaffHub) {
        this.addStaffHubContacts();
      }
      else if (this.mode === this.mailingMethods.CSV) {
        this.checkIfImportByCSV();
      }
 
      await this.$store.dispatch("updateFacilityMailingLists", this.mailing);

      this.close();
    },
    checkIfUserAlreadyAdded() {
      if (!this.mailing.to.find(x => x.email === this.customContact.email)) {
        this.mailing.to.push(this.customContact);
      }
    },
    addStaffHubContacts() {
     const existingIds = new Set(this.mailing.to.map(c => c.id));
      const existingEmails = new Set(this.mailing.to.map(c => c.email));

      const newContacts = this.selectedContacts
      .filter(x => !existingIds.has(x.id) && !existingEmails.has(x.email))
      .map(x => ({
        id: x.id,
        name: x.name,
        surname: "",
        userType: x.userType,
        email: x.email
      }));

      this.mailing.to.push(...newContacts);
    },
    checkIfImportByCSV() {
      if (!this.mailing.method.includes(this.mailingMethods.CSV)) {
        this.mailing.method = this.mailing.method + "+" + this.mailingMethods.CSV;
      }

      if (!this.csvData) return;

      this.csvData.forEach(item => {
        if (!this.mailing.to.find(x => x.email === item["Email"])) {
          this.mailing.to.push({
            id: uuidv4(),
            email: item["Email"],
            name: item["First Name"],
            surname: item["Last Name"] || "",
            userType: MailingListContactTypes.ImportedContact
          });
        }
      });
    },
    open() {
      this.dialog = true;
      this.mode = this.mailingMethods.StaffHub;
      this.mailing = {...this.currentMailingList}
    },
    close() {
      this.clearData()
      this.dialog = false;
    },
    onLoadFile(e) {
      if (!e || !e.currentTarget || !this.$papa || !this.$papa.parse) return;

      const file = e.currentTarget.files[0];
      this.filename = file.name;

      this.$papa.parse(file, {
        header: true,
        complete: this.onComplete,
        skipEmptyLines: true,
      });
    },
    onComplete(results, file) {
      this.clearError();

      if (file.type !== "text/csv" && file.type !== "application/vnd.ms-excel") {
        const message = this.$t('GeneralTranslations.PleaseUploadaCSVFile');
        this.setError(message);
        return;
      }

      if (!results.meta.fields.includes("Email") || !results.meta.fields.includes("First Name")) {
        const message = this.$t('GeneralTranslations.PleaseUploadaCSVFileByFollowingFormat') + " Email,First name,Last name (optional)";
        this.setError(message);
        return;
      }

      this.csv = results;
      this.csvData = results.data;
    },
    onChanageTypeOfContact(){
      this.selectedContacts = []
    },
    onContactSelected(){
      this.contactSearch = '';
    },
     toggleSelectAll() {
      if (this.allSelected) {
        this.selectedContacts = [];
      } else {
        this.selectedContacts = [...this.contactsList];
      }
      this.contactSearch = '';
    },
    clearError() {
      this.isError = false;
      this.errorContent = "";
    },
    setError(message) {
      this.isError = true;
      this.errorContent = message;
      this.filename = null;
      this.csv = null;
      this.$refs.input?.blur();
    },
    removeContactItemById(id){
      this.selectedContacts = this.selectedContacts.filter(c => c.id !== id);
    },
    onModeChanged(){
      this.clearData()
    },
    clearData(){
      this.selectedContacts = []
      this.selectedTypeOfContacts = null
      this.filename = null;
      this.csv = null;
      this.csvData = null;
      this.customContact = this.getEmptyCustomContactTemplate()
      this.$refs.observer?.reset();
      this.loading = false;
      this.clearError()
    },
    getEmptyCustomContactTemplate(){
      return { id: uuidv4(), name: "", surname: "", email: "", userType: MailingListContactTypes.CustomContact}
    },
    submitDisabled(invalid) {
      if (this.isCustomContact) return invalid;
      if (this.isStaffHubContacts) return !this.selectedContacts.length;
      return !this.csv;
    }
  }
};
